import { ReactNode } from 'react';

import useAppSelector from '~hooks/useAppSelector';
import { MediaLibrarySearchQueryProvider } from '~modules/media-library/context/MediaLibrarySearchQuery';
import { MediaLibrarySearchResultProvider } from '~modules/media-library/context/MediaLibrarySearchResult';
import { MediaLibrarySettingProvider } from '~modules/media-library/context/MediaLibrarySettings';
import { MediaLibraryUserPreferencesProvider } from '~modules/media-library/context/MediaLibraryUserPreferences';
import { selectConfigDefaultMediaLibraryRealm } from '~store/selectors';

export default function MediaLibraryProviderBag({ children, realm }: { children: ReactNode; realm?: string }) {
  const defaultRealm = useAppSelector(selectConfigDefaultMediaLibraryRealm);

  return (
    <MediaLibrarySettingProvider realm={realm || defaultRealm}>
      <MediaLibraryUserPreferencesProvider>
        <MediaLibrarySearchQueryProvider>
          <MediaLibrarySearchResultProvider>{children}</MediaLibrarySearchResultProvider>
        </MediaLibrarySearchQueryProvider>
      </MediaLibraryUserPreferencesProvider>
    </MediaLibrarySettingProvider>
  );
}
